import { observable, configure, flow } from "mobx";

import KidsApi from "@api/kids.api";
import studentsApi from "../api/students.api";

configure({ enforceActions: "observed" });

class StudentsStore {
  @observable kids = [];
  @observable students = [];
  @observable isLoading = false;
  @observable errors = null;

  fetchKidsList = flow(function* fetchKidsList(projectId: string) {
    this.isLoading = true;
    try {
      const kids = yield KidsApi.fetchList(projectId);

      this.kids = kids;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });

  fetchStudentsList = flow(function* fetchStudentList(projectId: string) {
    this.isLoading = true;
    try {
      const students = yield studentsApi.fetchList(projectId);

      this.students = students;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.errors = error;
    }
  });
}

export default new StudentsStore();
